<template>
  <div>
      <!-- @mouseover="isContentTabButtonActive = true"
      @mouseleave="isContentTabButtonActive = false" -->
      <!-- :class="{ 'hide': !isContentTabButtonActive }" -->
    <vs-button
      v-show="!sidePanelActive"
      @click="$emit('toggleSidePanel',true)"
      color="black"
      type="filled" class="content-tab-button p-2 pb-1 pr-5 flex-inline"
    >
      <feather-icon class="cursor-pointer" icon="MenuIcon" svgClasses="text-white stroke-current h-5 w-5 mr-2 p-0" />
      <span class="my-auto">
        {{ $t("general.view-content-list" )}}
      </span>
    </vs-button>
  </div>
</template>

<script>
export default {
  props:[
    'sidePanelActive'
  ],
}
</script>

<style>

</style>
